import { CostInputUoM, CostItem } from "types/common.types";
import { UserResponse } from "types/responses.type";

export function isAdmin(user: UserResponse | null) {
  return Boolean(user?.type && ["ADMIN", "SUPPORT"].includes(user.type));
}

export const DEFAULT_COURIER_COSTS: Record<string, CostItem> = {
  wage: {
    uom: CostInputUoM.HOUR,
    description: "Courier wage (hourly rate)",
  },
  benefits: {
    uom: CostInputUoM.HOUR,
    description: "Courier benefits (hourly rate)",
  },
  insurance: {
    uom: CostInputUoM.MONTH,
    description: "Courier insurance (monthly)",
  },
  mealAllowance: {
    uom: CostInputUoM.DAY,
    description: "Meal allowance (daily)",
  },
  travelAllowance: {
    uom: CostInputUoM.DAY,
    description: "Travel allowance (daily)",
  },
};

export const DEFAULT_VEHICLE_COSTS: Record<string, CostItem> = {
  fuel: {
    uom: CostInputUoM.MILE,
    description: "Vehicle fuel (per mile)",
  },
  maintenance: {
    uom: CostInputUoM.MONTH,
    description: "Vehicle maintenance (monthly)",
  },
  insurance: {
    uom: CostInputUoM.MONTH,
    description: "Vehicle insurance (monthly)",
  },
  depreciation: {
    uom: CostInputUoM.MONTH,
    description: "Vehicle depreciation (monthly)",
  },
  registration: {
    uom: CostInputUoM.YEAR,
    description: "Vehicle registration (yearly)",
  },
};
